import { useAuth } from "@/lib/use-auth";
import { useMemo } from "react";
import { DataTable } from "./documents-table/data-table";
import { columns } from "./documents-table/columns";

export const MyDocumentsAsEmployee = () => {
  const { data } = useAuth();

  const documents = useMemo(() => {
    const result = data?.user?.documents as {
      doc: string;
      url: string;
    }[];

    return result;
  }, [data]);

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Documents</h2>

      <DataTable columns={columns} data={documents} />
    </div>
  );
};
